import { Card } from "antd";
import { Orders } from "@modules";
import { Breadcrumb } from "@components";
import { useParams } from "react-router-dom";

export default function OrderPage() {
  const { id } = useParams();

  return (
    <div className="container max-content">
      <Breadcrumb
        data={[
          { title: "Orders", href: "/orders" },
          { title: "Details", href: `/orders/view/${id}` },
        ]}
      />
      <h1 className="mb-8 text-3xl">Order Details</h1>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12">
          <Card bordered={false}>
            <Orders.View orderId={id} />
          </Card>
        </div>
      </div>
    </div>
  );
}
